import { Chip } from "@mui/material";

export const HostedChip = ({
  inheritColor = false,
}: {
  inheritColor?: boolean;
}) => {
  return (
    <Chip
      label="Hosted"
      size="small"
      variant="outlined"
      className={inheritColor ? "text-inherit! dark:border-white!" : ""}
    />
  );
};
